// ModalComponent.vue
<template>
  <div>
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
    <div class='modal-content'>
    <div class='modal-header'>
        <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
        <h4 class='modal-title' id='myModalLabel'>hdfghdfghdfg</h4>
    </div>
    <div class='modal-body'>
    <vue-tabs active-tab-color="#6DBCF1"
    active-text-color="white"
    centered
    v-model="tabName"
    @tab-change="handleTabChange">
    <v-tab title="البيانات" icon="ti-user">
      <Data ref="Data"> </Data>
    </v-tab>

    <v-tab v-if="$per.value.Contract_show" id = "1" title="العقد" icon="ti-settings">
      <!-- <Contracts ref="Contracts"> </Contracts> -->
    </v-tab>
    <v-tab v-if="$per.value.InstallmentPaymrnt_show"  id = "2" title="السداد" icon="ti-check">
      <!-- <InstallmentPaymrnt ref="InstallmentPaymrnt"> </InstallmentPaymrnt> -->
    </v-tab>
    <v-tab id = "3" title="جدولة" icon="ti-check">
      <!-- <MaintenanceSchedule  ref="MaintenanceSchedule"> </MaintenanceSchedule> -->
    </v-tab>
    <v-tab v-if="$per.value.Maintenance_show" id = "4" title="الصيانة" icon="ti-check">
      <!-- <Maintenance  ref="Maintenance"> </Maintenance> -->
    </v-tab>
    <v-tab v-if="$per.value.Receipt_show" id = "5" title="التحصيل" icon="ti-check">
      <!-- <receipts ref="receipt"> </receipts> -->
    </v-tab>
    <v-tab v-if="$per.value.MaintenanceRequest_show" id = "6" title="مرتجعات" icon="ti-check">
      <!-- <SalesReturn  ref="SalesReturn"> </SalesReturn> -->
    </v-tab>
    <v-tab v-if="$per.value.MaintenanceRequest_show" id = "7" title="عرض" icon="ti-check">
      <!-- <OM  ref="OM"> </OM> -->
    </v-tab>
    <v-tab v-if="$per.value.MaintenanceRequest_show" id = "8" title="المكالمات" icon="ti-check">
      <!-- <CallLogs  ref="CallLogs"> </CallLogs> -->
    </v-tab>
    <v-tab v-if="$per.value.MaintenanceRequest_show" id = "9" title="الحسابات" icon="ti-check">
      <!-- <CustomerBalanceSheet  ref="CustomerBalanceSheet"> </CustomerBalanceSheet> -->
    </v-tab>
  </vue-tabs>
</div>
<div class='modal-footer'>
    <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
</div>
  </div>
  </div>
  </div>
  </div>
</template>
<script>
// import Swal from 'sweetalert2'
// import CustomerBalanceSheet from '@/components/Sales/Contracts/CustomerBalanceSheet'
// import Receipts from '@/components/Sales/Contracts/Receipts'
// import Contracts from '@/components/Sales/Contracts/Contracts'
// import InstallmentPaymrnt from '@/components/Sales/Contracts/InstallmentPaymrnt'
// import Data from '@/components/Sales/Contracts/Data'
// import Maintenance from '@/components/Sales/Contracts/Maintenance'
// import OM from '@/components/Sales/Contracts/OM'
// import MaintenanceSchedule from '@/components/Sales/Contracts/MaintenanceSchedule'
// import SalesReturn from '@/components/Sales/Contracts/SalesReturn'
// import CallLogs from '@/components/Sales/Contracts/CallLogs'
// import Problems from '@/components/Sales/Contracts/Problems'
// import axios from 'axios'
export default {
  name: 'CustomerDetails',
  // components: {
  //   Receipts,
  //   Contracts,
  //   InstallmentPaymrnt,
  //   MaintenanceSchedule,
  //   CustomerBalanceSheet,
  //   Maintenance,
  //   CallLogs,
  //   Problems,
  //   SalesReturn,
  //   OM,
  //   Data
  // },
  data () {
    return {
      disabled: true,
      tabName: 'بيانات العميل'
    }
  },
  methods: {
    setCustomerID (id) {
      console.log(id)
    },
    // =========================================================================
    handleTabChange (tabIndex, newTab, oldTab) {
      console.log('fffffffffffffffffff')
      if (newTab.id === '1') {
        // this.$refs.Contracts.tabSelected()
      } else if (newTab.id === '2') {
        // this.$refs.InstallmentPaymrnt.tabSelected(0)
      } else if (newTab.id === '3') {
        // this.$refs.MaintenanceSchedule.tabSelected()
      } else if (newTab.id === '4') {
        // this.$refs.Maintenance.tabSelected()
      } else if (newTab.id === '5') {
        // this.$refs.receipt.tabSelected()
      } else if (newTab.id === '6') {
        // this.$refs.SalesReturn.tabSelected()
      } else if (newTab.id === '7') {
        // this.$refs.OM.tabSelected()
      } else if (newTab.id === '8') {
        // this.$refs.CallLogs.tabSelected()
      } else if (newTab.id === '9') {
        // this.$refs.CustomerBalanceSheet.tabSelected()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/myComponents/CustomerDetails.vue